export const AI_CHAT_CONFIG_ADMIN = {
  apiUrl: "https://uat.onecityapp.hr",
  tenantId: "0b6c9259-7e9f-4e30-a53b-f3e7dc343c8c",
  title: "PFB Asistent",
  excerpt: "powered by Combis",
  enabled: true,
};
export const AI_CHAT_CONFIG_USER = {
  apiUrl: "https://uat.onecityapp.hr",
  tenantId: "ff881ce3-d8cf-415b-9168-61914f821e73",
  title: "Teo",
  excerpt: "powered by HT",
  enabled: true,
};
